module.exports = __webpack_public_path__ + "img/chevron-down.8f5609b6.svg";